import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { ADDRESS_CATEGORY_CONSTANTS, APP_CONSTANTS, CLIENT_TYPE_CONSTANTS, COMMON_CONSTANTS, DATE_FORMAT_CONSTATNS, MESSAGE_CATEGORY_CONSTATNS, MESSAGE_CONSTATNS, SO_ACTION_PERMISSION_CONSTANTS } from "../../../shared/constants/constant";
import {
    soActionPermissionViewModel,
    SoViewPriceWithorWithoutPrice,
    SoViewPriceWithorWithoutPricePdf,
    soViewSpecialInstructionBase,
    soViewWithPriceWithoutPriceModel
} from "../../models/service-order.model";
import { soPrepareSpecialInstCatDisplayUpdateForSOViewDTO, soPrepareSpecialInstNoteUpdateForSOViewDTO, soPrepareSpecialInstructionViewModel } from "../../models/service-order-prepare.model";
import {ActivatedRoute, Router} from "@angular/router";
import {ServiceOrderService} from "../../services/service-order.service";
import {CommonToastService} from "../../../shared/services/common-toast.service";
import {ServiceOrderPrepareService} from "../../services/service-order-prepare.service";
import {ServiceOrderScopeBoothService} from "../../services/service-order-scope-booth.service";
import {CommonService} from "../../../shared/services/common.service";
import {ApiResponse} from "../../../shared/common-model/common.model";

@Component({
    selector: 'app-service-order-view-pdf',
    templateUrl: './service-order-view-pdf.component.html',
    styleUrl: './service-order-view-pdf.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
//http://localhost:4200//soviewpdf/SOMS_ca0b13d7-8e2a-40f8-8817-1cfeeb7a5a78/False/
//This is second level call from API controller method for actual rendering of SO View HTML, which can be downloaded as PDF
export class ServiceOrderViewPdfComponent implements OnInit {

    //region [Member variables]
    serviceOrderId = "";
    withoutPrice = false;
    soView!: soViewWithPriceWithoutPriceModel;
    selectedSpInstForNoteUpdate!: soPrepareSpecialInstructionViewModel;
    selectedSpInstForCategoryDispUpdate!: soViewSpecialInstructionBase;
    EXHIBITORS = CLIENT_TYPE_CONSTANTS.EXHIBITORS;
    EXHIBIT_HOUSE = CLIENT_TYPE_CONSTANTS.EXHIBIT_HOUSE;
    NATEXT = COMMON_CONSTANTS.NA_TEXT;
    DT_Format_YYYY_MM_DD = DATE_FORMAT_CONSTATNS.YYYY_MM_DD;
    YYYY_MM_DD_ddd = DATE_FORMAT_CONSTATNS.YYYY_MM_DD_ddd;
    DAY_NAME_MONTH_DAY_YEAR = DATE_FORMAT_CONSTATNS.DAY_NAME_MONTH_DAY_YEAR;
    DAY_NAME_MONTH_DAY_YEAR_AM_PM = DATE_FORMAT_CONSTATNS.DAY_NAME_MONTH_DAY_YEAR_AM_PM;
    APP_NAME = APP_CONSTANTS.APP_NAME;
    isOpenSpInstNoteUpdateDialog = false;
    isLoadingSpInstNoteUpdateDialog = false;
    actionMenuPermissionList: soActionPermissionViewModel[] = [];
    isOpenSpInstCateCategoryUpdateDialog = false;
    isLoadingSpInstCategoryUpdateDialog = false;
    updatedInstructionNoteText = "";
    updatedInstructionCatDisplayText = "";
    SETUP_UPDATE = SO_ACTION_PERMISSION_CONSTANTS.SETUP_UPDATE;
    //endregion [Member variables]

    constructor(private router: Router, private soService: ServiceOrderService,
                private commonToastService: CommonToastService, private serviceOrderPrepareService: ServiceOrderPrepareService,
                private boothService: ServiceOrderScopeBoothService,
                private commonService: CommonService, private route: ActivatedRoute) {
        console.log('ServiceOrderViewPdfComponent - constructor');
        this.route.params.subscribe(params => {
            this.serviceOrderId = params['id'];
            this.withoutPrice =(params['price'] === 'True' || params['price'] === 'true') ? true : false;
        });
    }

    ngOnInit(): void {
        this.getSOView(this.serviceOrderId, this.withoutPrice);//This just gives view
        //this.downloadSOViewPDF(this.includePrice);//This is download PDF function also
    }

    getSOView(soId_:string, withoutPrice_: boolean) {
        const soViewParams: SoViewPriceWithorWithoutPricePdf = {
            token: 'add token here',
            serviceOrderId: soId_,
            serviceOrderNumber: this.soView?.serviceOrderFullNumber,
            isWithoutPrice: withoutPrice_
        };

        //this.spinnerService.show();
        this.soService.getSOViewPDFWithOrWithoutPrice(soViewParams).subscribe({
            next: (response: soViewWithPriceWithoutPriceModel) => {
                console.log("response");
                console.log(response);
                this.soView = response;
                //this.spinnerService.hide();
                //this.soService.getSoActionPermissionByServiceOrder(this.serviceOrderId);
            },
            error: (error) => {
                //this.spinnerService.hide();
                if (error?.status !== 401) {
                    this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, error?.message);
                }
            }
        });
    }

    ///TODO: Remove the method, not used
    downloadSOViewPDF(includePrice_: boolean) {
        //this.spinnerService.show();//Not required for SO View PDF download
        const soDetails: SoViewPriceWithorWithoutPricePdf = {
            token: 'add token here',
            serviceOrderId: this.serviceOrderId,
            serviceOrderNumber: this.soView.serviceOrderFullNumber,
            isWithoutPrice: includePrice_
        };

        this.soService.getSOViewPDFWithOrWithoutPrice(soDetails).subscribe({
            next: (response) => {
                if (this.commonService.isNotNULLEmptyUndefind(response)) {
                    this.soView = response;
                    //this.spinnerService.hide();//Not required for SO View PDF download
                    // this.soService.getSoActionPermissionByServiceOrder(this.serviceOrderId);
                    const newBlob = new Blob([response]);
                    const data = window.URL.createObjectURL(newBlob);
                    const link = document.createElement("a");
                    link.href = data;
                    link.download = "SO.pdf"; //this.soView.serviceOrderFullNumber +"_"+ this.soView.serviceOrderVersion + ".pdf"; // set a name for the file
                    link.click();
                    //this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.SUCCESS, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, MESSAGE_CONSTATNS.SO_VIEW_PDF);//Not required for SO View PDF download
                    //this.spinnerService.hide();//Not required for SO View PDF download
                } else {
                    this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.WEEKLY_MEETING, MESSAGE_CONSTATNS.FILE_DOWNLOAD_ISSUE);
                    //this.spinnerService.hide();//Not required for SO View PDF download
                }
                //this.spinnerService.hide();//Not required for SO View PDF download
            },
            error: (error) => {
                console.log(error);
                //this.spinnerService.hide();//Not required for SO View PDF download
                if (error?.status !== 401) {
                    this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, error?.message);
                }
            }
        });

        // if (includePrice_) {//with price
        //     this.soService.getSOViewPDFWithPrice(this.serviceOrderId).subscribe({
        //         next: (response) => {
        //             if (this.commonService.isNotNULLEmptyUndefind(response)) {
        //                 this.soView = response;
        //                 this.spinnerService.hide();
        //                // this.soService.getSoActionPermissionByServiceOrder(this.serviceOrderId);
        //                 const newBlob = new Blob([response]);
        //                 const data = window.URL.createObjectURL(newBlob);
        //                 const link = document.createElement("a");
        //                 link.href = data;
        //                 link.download = "SO.pdf"; //this.soView.serviceOrderFullNumber +"_"+ this.soView.serviceOrderVersion + ".pdf"; // set a name for the file
        //                 link.click();
        //                 this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.SUCCESS, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, MESSAGE_CONSTATNS.SO_VIEW_PDF);
        //                 this.spinnerService.hide();
        //             } else {
        //                 this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.WEEKLY_MEETING, MESSAGE_CONSTATNS.FILE_DOWNLOAD_ISSUE);
        //                 this.spinnerService.hide();
        //             }
        //             this.spinnerService.hide();
        //         },
        //         error: (error) => {
        //             console.log(error);
        //             this.spinnerService.hide();
        //             if (error?.status !== 401) {
        //                 this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, error?.message);
        //             }
        //         }
        //     });
        // } else {//wihtout price
        //     this.soService.getSOViewPDFWithoutPrice(soDetails).subscribe({
        //         next: (response) => {
        //             if (this.commonService.isNotNULLEmptyUndefind(response)) {
        //                 this.soView = response;
        //                 this.spinnerService.hide();
        //                 // this.soService.getSoActionPermissionByServiceOrder(this.serviceOrderId);
        //                 const newBlob = new Blob([response]);
        //                 const data = window.URL.createObjectURL(newBlob);
        //                 const link = document.createElement("a");
        //                 link.href = data;
        //                 link.download = "bing.pdf"; //this.soView.serviceOrderFullNumber +"_"+ this.soView.serviceOrderVersion + ".pdf"; // set a name for the file
        //                 link.click();
        //                 this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.SUCCESS, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, MESSAGE_CONSTATNS.SO_VIEW_PDF);
        //                 this.spinnerService.hide();
        //             } else {
        //                 this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.WEEKLY_MEETING, MESSAGE_CONSTATNS.FILE_DOWNLOAD_ISSUE);
        //                 this.spinnerService.hide();
        //             }
        //             this.spinnerService.hide();
        //         },
        //         error: (error) => {
        //             console.log(error);
        //             this.spinnerService.hide();
        //             if (error?.status !== 401) {
        //                 this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, error?.message);
        //             }
        //         }
        //     });
        // }
    }

    getCompanyName() {
        return this.commonService.getCompanyInfo().companyName;
    }

    getCompanyDetails() {
        return this.commonService.getCompanyInfo();
    }

    getTimeAMPM(time: string) {
        return this.commonService.getAmPmTimeFrom24Time(time)
    }

    getDialCode(dialCode: string) {
        return this.commonService.getDialCode(dialCode);
    }

    getMaterialWaivedAmount(amount: any) {
        return "Waived Amount:$ " + amount.toFixed(2);
    }

    openSpecialInstNoteUpdateDialog(item: soPrepareSpecialInstructionViewModel) {
        this.isOpenSpInstNoteUpdateDialog = true;
        this.selectedSpInstForNoteUpdate = item;
        this.updatedInstructionNoteText = item.instructionNote;
    }

    closeSpecialInstNoteUpdateDialog() {
        this.isOpenSpInstNoteUpdateDialog = false;
        this.selectedSpInstForNoteUpdate = {} as soPrepareSpecialInstructionViewModel;
    }

    openSpecialInstCatDisplayUpdateDialog(item: soViewSpecialInstructionBase) {
        this.isOpenSpInstCateCategoryUpdateDialog = true;
        this.selectedSpInstForCategoryDispUpdate = item;
        this.updatedInstructionCatDisplayText = item.specialInstCategoryDisplayName;
    }

    checkActionPermission(key: string) {
        const actionData = this.actionMenuPermissionList.find(r => r.actionKey == key);
        if (this.commonService.isNotNULLEmptyUndefind(actionData)) {
            return actionData?.access;
        }
        return false;
    }

    closeSpecialInstCatDisplayUpdateDialog() {
        this.isOpenSpInstCateCategoryUpdateDialog = false;
        this.selectedSpInstForCategoryDispUpdate = {} as soViewSpecialInstructionBase;
    }

    getDataIfNotNull(data: any) {
        return this.commonService.isNotNULLEmptyUndefind(data);
    }

    downloadInboundFile(fileId: string, fileName: string) {
        //this.spinnerService.show();
        this.serviceOrderPrepareService.billDownload(fileId).subscribe({
            next: (response) => {
                if (this.commonService.isNotNULLEmptyUndefind(response)) {
                    const newBlob = new Blob([response]);
                    const data = window.URL.createObjectURL(newBlob);
                    const link = document.createElement("a");
                    link.href = data;
                    link.download = fileName; // set a name for the file
                    link.click();
                } else {
                    this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, MESSAGE_CONSTATNS.FILE_DOWNLOAD_ISSUE);
                }
                //this.spinnerService.hide();
            },
            error: (error: any) => {
                this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, error);
            },
        });
    }

    getAddressCategory(key: string) {
        if (key === ADDRESS_CATEGORY_CONSTANTS.BILL_TO) {
            return ADDRESS_CATEGORY_CONSTANTS.BILL_TO_DISPLAY_NAME;
        }
        if (key === ADDRESS_CATEGORY_CONSTANTS.SHIP_TO) {
            return ADDRESS_CATEGORY_CONSTANTS.SHIP_TO_DISPLAY_NAME;
        }
        if (key === ADDRESS_CATEGORY_CONSTANTS.OTHER) {
            return ADDRESS_CATEGORY_CONSTANTS.OTHER_DISPLAY_NAME;
        }
        return key;
    }

    downloadOutboundFile(fileId: string, fileName: string) {
        //this.spinnerService.show();
        this.serviceOrderPrepareService.outBoundbillDownload(fileId).subscribe({
            next: (response) => {
                if (this.commonService.isNotNULLEmptyUndefind(response)) {
                    const newBlob = new Blob([response]);
                    const data = window.URL.createObjectURL(newBlob);
                    const link = document.createElement("a");
                    link.href = data;
                    link.download = fileName; // set a name for the file
                    link.click();
                } else {
                    this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, MESSAGE_CONSTATNS.FILE_DOWNLOAD_ISSUE);
                }
                //this.spinnerService.hide();
            },
            error: (error: any) => {
                this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, error);
            },
        });
    }

    downloadBoothFile(fileId: string, fileName: string) {
        //this.spinnerService.show();
        this.boothService.downloadSoScopeBoothFieldFile(fileId).subscribe({
            next: (response) => {
                if (this.commonService.isNotNULLEmptyUndefind(response)) {
                    const newBlob = new Blob([response]);
                    const data = window.URL.createObjectURL(newBlob);
                    const link = document.createElement("a");
                    link.href = data;
                    link.download = fileName; // set a name for the file
                    link.click();
                } else {
                    this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, MESSAGE_CONSTATNS.FILE_DOWNLOAD_ISSUE);
                }
                //this.spinnerService.hide();
            },
            error: (error) => {
                //this.spinnerService.hide();
                if (error?.status !== 401) {
                    this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, error?.message);
                }
            }
        });
    }

    /*back() {
        if (localStorage.getItem('so-view-back-to') === 'so-list-show') {
            this.router.navigate(['so/list-for-show', this.soView.showId]);
        } else if (localStorage.getItem('so-view-back-to') === 'so-list') {
            this.router.navigate(['so/list']);
        } else if (localStorage.getItem('so-view-back-to') === 'so-home') {
            const url = 'so/update/' + this.serviceOrderId + '/initiate/' + this.serviceOrderId + '/general-info';
            this.router.navigate([url]);
        }
        else if (localStorage.getItem('so-view-back-to') === 'job-budget-on') {
            this.router.navigate(['job-planning/job-budget/on']);
        }
        else if (localStorage.getItem('so-view-back-to') === 'job-budget-under') {
            this.router.navigate(['job-planning/job-budget/under']);
        }
        else if (localStorage.getItem('so-view-back-to') === 'job-budget-over') {
            this.router.navigate(['job-planning/job-budget/over']);
        }
        else if (localStorage.getItem('so-view-back-to') === 'job-labor-daily-activity') {
            this.router.navigate(['job-planning/daily-activity']);
        }
        else if (localStorage.getItem('so-view-back-to') === 'billing-entry') {
            this.router.navigate(['job-planning/billing-entry']);
        }
        else if (localStorage.getItem('so-view-back-to') === 'platinum-report') {
            this.router.navigate(['account-manager/platinum-report']);
        }
        else if (localStorage.getItem('so-view-back-to') === 'estimate-follow-up-report') {
            this.router.navigate(['account-manager/estimate-follow-up-report']);
        }
        else if (localStorage.getItem('so-view-back-to') === 'job-update-report') {
            this.router.navigate(['report/job-update-report']);
        }
        else if (localStorage.getItem('so-view-back-to') === 'job-update-report-view') {
            this.router.navigate(['report/job-update-report-view', this.serviceOrderId]);
        }
        else if (localStorage.getItem('so-view-back-to') === 'show-specific-report') {
            this.router.navigate(['report/show-specific-report']);
        }
        else if (localStorage.getItem('so-view-back-to') === 'show-comparison-report') {
            this.router.navigate(['report/show-comparison-report']);
        }
        else {
            this.router.navigate(['so/list']);
        }
    }*/

    soViewUpdateSpecialInstNote() {
        if (!this.commonService.isNotNULLEmptyUndefind(this.updatedInstructionNoteText)) {
            return;
        }
        const obj: soPrepareSpecialInstNoteUpdateForSOViewDTO = {
            instructionNote: this.updatedInstructionNoteText,
            serviceOrderId: this.serviceOrderId,
            soPrepareSpecialInstructionId: this.selectedSpInstForNoteUpdate.soPrepareSpecialInstructionId
        }
        this.isLoadingSpInstNoteUpdateDialog = true;
        this.serviceOrderPrepareService.soViewUpdateSpecialInstNote(obj).subscribe({
            next: (response: ApiResponse) => {
                this.commonToastService.showToasterMessage(response.msgCategoryKey, response.msgCategoryTitle, response.message);
                if (response.success) {
                    this.closeSpecialInstNoteUpdateDialog();
                    this.getSOView(this.serviceOrderId, this.withoutPrice);
                }
                this.isLoadingSpInstNoteUpdateDialog = false;
            },
            error: (error) => {
                this.isLoadingSpInstNoteUpdateDialog = false;
                if (error?.status !== 401) {
                    this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, error?.message);
                }
            }
        });
    }

    soViewUpdateSpecialInstCategoryDisplay() {
        if (!this.commonService.isNotNULLEmptyUndefind(this.updatedInstructionCatDisplayText)) {
            return;
        }
        const obj: soPrepareSpecialInstCatDisplayUpdateForSOViewDTO = {
            serviceOrderId: this.serviceOrderId,
            instructionCategoryDisplay: this.updatedInstructionCatDisplayText,
            instructionCategoryKey: this.selectedSpInstForCategoryDispUpdate.specialInstCategoryKey
        }
        this.isLoadingSpInstCategoryUpdateDialog = true;
        this.serviceOrderPrepareService.soViewUpdateSpecialInstCatDisplay(obj).subscribe({
            next: (response: ApiResponse) => {
                this.commonToastService.showToasterMessage(response.msgCategoryKey, response.msgCategoryTitle, response.message);
                if (response.success) {
                    this.closeSpecialInstCatDisplayUpdateDialog();
                    this.getSOView(this.serviceOrderId, this.withoutPrice);
                }
                this.isLoadingSpInstCategoryUpdateDialog = false;
            },
            error: (error) => {
                this.isLoadingSpInstCategoryUpdateDialog = false;
                if (error?.status !== 401) {
                    this.commonToastService.showToasterMessage(MESSAGE_CATEGORY_CONSTATNS.ERROR, MESSAGE_CATEGORY_CONSTATNS.SERVICE_ORDER, error?.message);
                }
            }
        });
    }

    getFileName(fileName: any) {
        if (this.commonService.isNotNULLEmptyUndefind(fileName)) {
            return fileName.split(".")[0];
        }
    }

}
